module.exports = __webpack_public_path__ + "6145472456acfe76ccd70e2b5c174536.pdf";